var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "lg accesses-list" },
      [
        (!_vm.loading || _vm.page > 1) && _vm.list.length
          ? _c(
              "scrolled-table",
              {
                attrs: { "fix-last": true },
                on: {
                  nextPage: function ($event) {
                    return _vm.$emit("nextPage")
                  },
                },
              },
              [
                _c("table", { staticClass: "h-table accesses-list__table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticClass: "accesses-list__name" }, [
                        _c("div", { staticClass: "h-table__header" }, [
                          _c(
                            "div",
                            {
                              staticClass: "h-table__col-title",
                              class: {
                                active: _vm.sortBy === "name",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.sort("name")
                                },
                              },
                            },
                            [_vm._v(" Название терминала ")]
                          ),
                        ]),
                      ]),
                      _c("th", { staticClass: "accesses-list__terminal" }, [
                        _c("div", { staticClass: "h-table__header" }, [
                          _c(
                            "div",
                            {
                              staticClass: "h-table__col-title",
                              class: {
                                active: _vm.sortBy === "terminal_id",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.sort("terminal_id")
                                },
                              },
                            },
                            [_vm._v(" ID терминала (IIKO) ")]
                          ),
                        ]),
                      ]),
                      _c("th", { staticClass: "accesses-list__host" }, [
                        _c("div", { staticClass: "h-table__header" }, [
                          _c(
                            "div",
                            {
                              staticClass: "h-table__col-title",
                              class: {
                                active: _vm.sortBy === "host",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.sort("host")
                                },
                              },
                            },
                            [_vm._v(" Хост ")]
                          ),
                        ]),
                      ]),
                      _c("th", { staticClass: "accesses-list__login" }, [
                        _c("div", { staticClass: "h-table__header" }, [
                          _c(
                            "div",
                            {
                              staticClass: "h-table__col-title",
                              class: {
                                active: _vm.sortBy === "login",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.sort("login")
                                },
                              },
                            },
                            [_vm._v(" Логин ")]
                          ),
                        ]),
                      ]),
                      _c("th", { attrs: { width: "70" } }),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.list, function (item) {
                      return _c(
                        "tr",
                        { key: item.id, staticClass: "iiko-access" },
                        [
                          _c("td", [_vm._v(_vm._s(item.name))]),
                          _c("td", [_vm._v(_vm._s(item.terminal_id))]),
                          _c("td", [_vm._v(_vm._s(item.host))]),
                          _c("td", [_vm._v(_vm._s(item.login))]),
                          _c("td", [
                            _c(
                              "div",
                              { staticClass: "iiko-access__actions" },
                              [
                                _c("c-button2", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.hover.blur.top",
                                      value: "Редактировать",
                                      expression: "'Редактировать'",
                                      modifiers: {
                                        hover: true,
                                        blur: true,
                                        top: true,
                                      },
                                    },
                                  ],
                                  staticClass: "iiko-access__edit",
                                  attrs: { size: "iconic", icon: "edit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("edit", item)
                                    },
                                  },
                                }),
                                _c("c-button2", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.hover.blur.top",
                                      value: "Удалить",
                                      expression: "'Удалить'",
                                      modifiers: {
                                        hover: true,
                                        blur: true,
                                        top: true,
                                      },
                                    },
                                  ],
                                  staticClass: "iiko-access__remove",
                                  attrs: {
                                    size: "iconic",
                                    icon: { icon: "trash", color: "secondary" },
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("remove", item)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm.loading
          ? _c("c-loader", {
              staticClass: "accesses-list__loading",
              attrs: {
                active: _vm.loading,
                label: "Данные загружаются",
                height: 200,
              },
            })
          : _vm._e(),
        !_vm.loading && !_vm.list.length
          ? _c("div", { staticClass: "accesses-list__empty" }, [
              _vm._v(
                " Ничего не найдено. Попробуйте изменить параметры поиска. "
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "accesses-list sm" },
      [
        (!_vm.loading || _vm.page > 1) && _vm.list.length
          ? _c(
              "horizontal-table",
              {
                on: {
                  nextPage: function ($event) {
                    return _vm.$emit("nextPage")
                  },
                },
              },
              [
                _c("table", { staticClass: "h-table" }, [
                  _c("tbody", [
                    _c(
                      "tr",
                      [
                        _c("th", [
                          _c("div", { staticClass: "h-table__header" }, [
                            _c(
                              "div",
                              {
                                staticClass: "h-table__col-title",
                                class: {
                                  active: _vm.sortBy === "name",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.sort("name")
                                  },
                                },
                              },
                              [
                                _vm._v(" Название"),
                                _c("br"),
                                _vm._v("терминала "),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._l(_vm.list, function (item) {
                          return _c("td", { key: item.id }, [
                            _vm._v(" " + _vm._s(item.name) + " "),
                          ])
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [
                          _c("div", { staticClass: "h-table__header" }, [
                            _c(
                              "div",
                              {
                                staticClass: "h-table__col-title",
                                class: {
                                  active: _vm.sortBy === "terminal_id",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.sort("terminal_id")
                                  },
                                },
                              },
                              [
                                _vm._v(" ID"),
                                _c("br"),
                                _vm._v("терминала"),
                                _c("br"),
                                _vm._v("(IIKO) "),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._l(_vm.list, function (item) {
                          return _c("td", { key: item.id }, [
                            _vm._v(" " + _vm._s(item.terminal_id) + " "),
                          ])
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [
                          _c("div", { staticClass: "h-table__header" }, [
                            _c(
                              "div",
                              {
                                staticClass: "h-table__col-title",
                                class: {
                                  active: _vm.sortBy === "host",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.sort("host")
                                  },
                                },
                              },
                              [_vm._v(" Хост ")]
                            ),
                          ]),
                        ]),
                        _vm._l(_vm.list, function (item) {
                          return _c("td", { key: item.id }, [
                            _vm._v(" " + _vm._s(item.host) + " "),
                          ])
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [
                          _c("div", { staticClass: "h-table__header" }, [
                            _c(
                              "div",
                              {
                                staticClass: "h-table__col-title",
                                class: {
                                  active: _vm.sortBy === "login",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.sort("login")
                                  },
                                },
                              },
                              [_vm._v(" Логин ")]
                            ),
                          ]),
                        ]),
                        _vm._l(_vm.list, function (item) {
                          return _c("td", { key: item.id }, [
                            _vm._v(" " + _vm._s(item.login) + " "),
                          ])
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th"),
                        _vm._l(_vm.list, function (item) {
                          return _c("td", { key: item.id }, [
                            _c(
                              "div",
                              { staticClass: "iiko-access__actions" },
                              [
                                _c("c-button2", {
                                  staticClass: "iiko-access__edit",
                                  attrs: { size: "iconic", icon: "edit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("edit", item)
                                    },
                                  },
                                }),
                                _c("c-button2", {
                                  staticClass: "iiko-access__remove",
                                  attrs: {
                                    size: "iconic",
                                    icon: { icon: "trash", color: "secondary" },
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("remove", item)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm.loading
          ? _c("c-loader", {
              staticClass: "accesses-list__loading",
              attrs: {
                active: _vm.loading,
                label: "Данные загружаются",
                height: 200,
              },
            })
          : _vm._e(),
        !_vm.loading && !_vm.list.length
          ? _c("div", { staticClass: "accesses-list__empty" }, [
              _vm._v(
                " Ничего не найдено. Попробуйте изменить параметры поиска. "
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }